// 越南语
export default {
  "请输入手机号或用户名": "Vui lòng nhập số điện thoại hoặc tên người dùng",
  "请输入密码": "Vui lòng nhập mật khẩu",
  "自动登录": "Đăng nhập tự động",
  "游戏试玩": "Trải nghiệm trò chơi miễn phí",
  "忘记密码": "Quên mật khẩu",
  "登录账户": "Đăng nhập tài khoản",
  "联系客服": "Liên hệ chăm sóc khách hàng",
  "注册账户": "Đăng ký tài khoản",
  "请选择你的语言": "Vui lòng chọn ngôn ngữ của bạn",
  "选择你的语言": "Choose your language",
  "英语": "English",
  "简体中文": "Tiếng Trung giản thể",
  "繁体中文": "Tiếng Trung phồn thể",
  "请输入确认密码": "Vui lòng nhập lại mật khẩu",

  "推荐人": "Người giới thiệu",
  "请输入验证码": "Vui lòng nhập mã xác nhận",
  "注册": "Đăng ký",
  "登录": "Đăng nhập",
  "返回登录": "Quay lại đăng nhập",
  "复制成功": "Sao chép thành công",
  "客服": "Hỗ trợ khách hàng",
  "大厅": "Sảnh chính",
  "发现": "Khám phá",
  "优惠": "Ưu đãi",
  "我的": "Của tôi",
  "会话": "Cuộc trò chuyện",
  "公告通知": "Thông báo",
  "上下分如有问题请及时联系客服": "Nếu có vấn đề về nạp/rút tiền, vui lòng liên hệ chăm sóc khách hàng kịp thời",
  "在线客服": "Hỗ trợ khách hàng trực tuyến",
  "提供各类问题疑难排解": "Cung cấp giải pháp cho các loại sự cố và vấn đề khác nhau",
  "Telegram客服": "Telegram",
  "Signal客服": "Dịch vụ khách hàng Signal",
  "Signal客服号码": "+1(971) 427 1149",
  "消息中心": "Trung tâm thông báo",
  "公告": "Thông cáo",
  "站内信": "Thư nội bộ",
  "没有更多了": "Không còn nữa",
  "请先登录或者注册": "Vui lòng đăng nhập hoặc đăng ký trước",
  "充值": "Nạp tiền",
  "转账": "Chuyển khoản",
  "提现": "Rút tiền",
  "IOS用户注意": "Lưu ý cho người dùng iOS",
  "尊敬的U8会员您好": "Kính chào thành viên U8 quý mến",
  "系统内容1": "Phiên bản mới của ứng dụng U8 International iOS đã được sửa lỗi và chính thức ra mắt, hiện đã có thể tải về.",
  "系统内容2": "Nhưng để đảm bảo truy cập ổn định lâu dài, chúng tôi khuyên bạn nên ưu tiên mở bằng trình duyệt Safari.",
  "系统内容3": "Nhấn vào phần dưới cùng📤Nhấn nút Chia sẻ” → Chọn “Thêm vào Màn hình chính” để truy cập nhanh vào nền tảng.",

  "系统内容4": "Nếu muốn sử dụng ứng dụng, vui lòng truy cập trang web chính thức.",
  "系统内容5": "Truy cập trang chủ, nhấn vào nút 【Tải xuống】 ở góc trên bên phải để lấy phiên bản mới nhất.",
  "系统内容6": "Nếu có thắc mắc, vui lòng liên hệ với bộ phận hỗ trợ chính thức.",

  "系统内容7": "Hỗ trợ xử lý",
  "系统内容8": "Cảm ơn sự ủng hộ và thông cảm của bạn!",
  "系统内容9": "Đội ngũ vận hành U8 International",
  "公平": "Công bằng",
  "公正": "Công lý",
  "公开": "Công khai",
  "官方投注机器人":  "Robot đặt cược chính thức",
  "系统内容10": "Thực hiện trực tiếp các thao tác như chơi game, nạp tiền, rút tiền, v.v.",
  "搜索": "Tìm kiếm",
  "系统内容11": "Cảm ơn sự thông cảm và ủng hộ của bạn, chúc bạn chơi game vui vẻ!",
  "今日不再弹出": "Không hiển thị lại hôm nay",
  "添加": "Thêm vào",
  "到手机主页屏幕": "Vào màn hình chính của điện thoại",
  "选择分享按钮": "Chọn nút chia sẻ",
  "点击": "Nhấn vào",
  "加至主画面": "Thêm vào màn hình chính",
  "点击「加入」按钮": "Nhấn vào nút 「Thêm」",
  "存款": "Gửi tiền",
  "网银转账": "Chuyển khoản ngân hàng trực tuyến",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "收款账号": "Tài khoản nhận tiền",
  "复制": "Sao chép",
  "银行户名": "Tên chủ tài khoản ngân hàng",
  "开户行": "Ngân hàng mở tài khoản",
  "银行地址": "Địa chỉ ngân hàng",
  "开户银行": "Ngân hàng phát hành tài khoản",
  "选择开户银行": "Chọn ngân hàng mở tài khoản",
  "存款人姓名": "Tên người gửi tiền",
  "请输入存款人姓名": "Vui lòng nhập tên người gửi tiền",
  "请务必输入正确的存款人姓名": "Để tiền được chuyển ngay lập tức, vui lòng chắc chắn nhập đúng tên người gửi tiền.",
  "银行卡号": "Số thẻ ngân hàng",
  "请输入银行卡号": "Vui lòng nhập số thẻ ngân hàng",
  "开户行地址": "Địa chỉ ngân hàng mở tài khoản",
  "请输入开户行地址": "Địa chỉ ngân hàng mở tài khoản",
  "请输入银行开户行地址": "Vui lòng nhập địa chỉ ngân hàng mở tài khoản",
  "存款金额": "Số tiền nạp",
  "请输入取款金额": "Vui lòng nhập số tiền rút",
  "元": "VND",
  "USDT价格稳定": "Giá USDT ổn định",
  "流通性高": "Tính thanh khoản cao",
  "不受监管": "Không bị kiểm soát",
  "了解更多": "Tìm hiểu thêm",
  "绑定协议地址": "Chuyển tiền giữa các sàn giao dịch",
  "交易所划转": "Liên kết địa chỉ hợp đồng",
  "完成取款": "Hoàn tất rút tiền",
  "钱包协议": "Giao thức ví",
  "温馨提示": "Lời nhắc thân thiện",
  "温馨提示内容": "Vui lòng chọn đúng giao thức thanh toán USDT. Nếu bạn chọn sai giao thức, nền tảng sẽ không nhận được thanh toán của bạn, và chúng tôi sẽ không chịu bất kỳ trách nhiệm nào về việc này！",
  "立即存款": "Nạp tiền ngay",
  "存款遇到问题": "Gặp sự cố khi nạp tiền",
  "联系": "Liên hệ",
  "人工客服": "Hỗ trợ khách hàng trực tiếp",
  "解决": "Giải quyết",
  "银行类型": "Loại ngân hàng",
  "请输入银行类型": "Vui lòng nhập loại ngân hàng",
  "请输入金额区间": "Vui lòng nhập số tiền trong khoảng {min_price}-{max_price}！",
  "等待后台审核": "Gửi thành công, vui lòng chờ bộ phận kiểm duyệt xử lý",
  "场馆转账": "Chuyển tiền giữa các sòng/địa điểm chơi",
  "余额自动转入": "Số dư tự động chuyển vào",
  "启用后余额自动转入转出游戏场馆": "Sau khi kích hoạt, số dư sẽ tự động chuyển vào hoặc ra khỏi sòng/trò chơi.",
  "请输入转账金额": "Vui lòng nhập số tiền chuyển khoản",
  "全部转入": "Chuyển toàn bộ vào",
  "可转账金额": "Số tiền có thể chuyển",
  "确认转账": "Xác nhận chuyển khoản",
  "场馆余额明细": "Chi tiết số dư sòng/trò chơi",
  "点击查看全部场馆余额": "Nhấn để xem toàn bộ số dư các sòng/trò chơi",
  "主钱包": "Ví chính",
  "一键取回": "Rút về chỉ với một lần nhấn",
  "收起": "Thu gọn",
  "展开": "Mở rộng",
  "请输入操作金额": "Vui lòng nhập số tiền thao tác",
  "场馆内钱包不支持互转": "Ví trong sòng/trò chơi không hỗ trợ chuyển đổi lẫn nhau",
  "操作成功": "Thao tác thành công",
  "VIP特权": "Đặc quyền VIP",
  "已达标": "Đã đạt tiêu chuẩn",
  "未达标": "Chưa đạt tiêu chuẩn",
  "累计存款": "Tổng số tiền nạp tích lũy",
  "流水要求": "Yêu cầu doanh thu cược",
  "VIP最高返水比例": "Tỷ lệ hoàn trả cao nhất cho VIP",
  "VIP等级": "Cấp độ VIP",
  "真人": "Trực tiếp",
  "体育": "Thể thao",
  "电竞": "Esports",
  "棋牌": "Bài và cờ",
  "电子": "điện tử",
  "彩票": "xổ số",
  "活动规则": "Quy tắc hoạt động",
  "晋升标准": "Tiêu chuẩn thăng chức",
  "规则内容1": "Khi tổng số tiền gửi và tổng số giao dịch của thành viên đạt đến mức yêu cầu tương ứng, thành viên sẽ được nâng cấp lên cấp VIP tương ứng trước 24 giờ ngày hôm sau.。",
  "晋升顺序": "Thứ tự thăng chức",
  "规则内容2": "Khi đạt được yêu cầu tương ứng, cấp VIP có thể được thăng cấp mỗi ngày, nhưng không thể thăng cấp vượt cấp.。",
  "保级要求": "Yêu cầu trụ hạng",
  "规则内容3": "Sau khi đạt được một cấp độ VIP nhất định, thành viên phải hoàn thành yêu cầu doanh thu để duy trì cấp độ trong vòng 90 ngày. Nếu trong thời gian này thành viên được thăng cấp, yêu cầu duy trì cấp độ sẽ được tính lại theo cấp độ hiện tại.。",
  "降级标准": "Tiêu chuẩn hạ cấp",
  "规则内容4": "Nếu thành viên không hoàn thành yêu cầu doanh thu tương ứng để duy trì cấp độ trong một quý (tính theo 90 ngày), hệ thống sẽ tự động hạ cấp một bậc, và các khoản hoàn tiền cùng các ưu đãi khác cũng sẽ được điều chỉnh theo cấp độ mới sau khi hạ cấp.。",
  "VIP返水": "Hoàn tiền VIP",
  "规则内容5": "Số tiền hoàn lại VIP được tính dựa trên các cược hợp lệ của thành viên trong khoảng thời gian từ 00:00 đến 23:59 theo giờ Bắc Kinh trong ngày. Tất cả số tiền hoàn lại từ các cược trong ngày sẽ được chuyển vào Trung tâm Phúc lợi trong vòng 24 giờ sau khi kết thúc ngày thanh toán cược. Vui lòng truy cập Trung tâm Phúc lợi trong Trung tâm Cá nhân để nhận tiền hoàn lại thủ công. (Hoàn lại VIP có thể rút tiền sau khi đạt 1 lần doanh thu)",
  "规则内容6": "U8 Entertainment reserves the right to modify, suspend, and make the final interpretation of the event.",
  "取款": "Rút tiền",
  "银行卡取款": "Rút tiền từ thẻ ngân hàng",
  "钱包金额": "Số tiền trong ví",
  "一键回收": "Một nút thu hồi",
  "中心钱包": "Ví trung tâm",
  "游戏钱包": "trò chơi",
  "选择USDT地址": "Chọn địa chỉ USDT",
  "请选择USDT地址": "Chọn địa chỉ USDT",
  "添加USDT地址": "Thêm địa chỉ USDT",
  "打码量": "Lượng mã hóa",
  "取款金额": "Số tiền rút",
  "最大金额": "Số tiền tối đa",
  "支付密码": "Mật khẩu thanh toán",
  "请输入支付密码": "Vui lòng nhập mật khẩu thanh toán",
  "每笔手续费": "Mỗi khoản phí dịch vụ",
  "折合USDT": "Tương đương USDT",
  "参考汇率": "Tỷ giá tham khảo",
  "实时变化": "Thay đổi theo thời gian thực",
  "实际到账": "Thực tế đã nhận được tiền",
  "选择银行卡": "Chọn thẻ ngân hàng",
  "请选择银行卡": "Chọn thẻ ngân hàng",
  "添加银行卡": "Thêm thẻ ngân hàng",
  "立即取款": "Rút tiền ngay lập tức",
  "取款遇到问题": "Gặp sự cố khi rút tiền",
  "真实姓名": "Tên thật",
  "绑定真实姓名后不可修改": "Sau khi liên kết tên thật, không thể sửa đổi.",
  "确认修改": "Xác nhận sửa đổi",
  "请选择您要提现到的银行卡": "Vui lòng chọn thẻ ngân hàng mà bạn muốn rút tiền về.",
  "单笔取款不能低于100元": "Mỗi lần rút tiền không được dưới 100 nhân dân tệ.",
  "请输入您的支付密码": "Vui lòng nhập mật khẩu thanh toán của bạn",
  "请填写用户实名信息": "Vui lòng điền thông tin tên thật của người dùng",
  "提交成功": "Gửi thành công",
  "优惠活动": "Chương trình khuyến mãi",
  "全部优惠": "Tất cả ưu đãi",
  "限时活动": "Hoạt động có thời hạn",
  "新人首存": "Tiền gửi đầu tiên của người mới",
  "日常活动": "Hoạt động hàng ngày",
  "暂未设置签名": "Chưa thiết lập chữ ký",
  "账户总资产": "Tổng tài sản tài khoản",
  "我的钱包": "Ví của tôi",
  "账户明细": "Chi tiết tài khoản",
  "投注记录": "Lịch sử đặt cược",
  "安全设置": "Cài đặt an toàn",
  "我的等级": "Cấp độ của tôi",
  "VIP中心": "Trung tâm VIP",
  "邀请好友": "Mời bạn bè",
  "推荐送礼金": "Gợi ý quà tặng tiền mặt",
  "官方公告": "Thông báo chính thức",
  "坐收盈利": "thu lợi nhuận",
  "合营计划": "Kế hoạch hợp tác",
  "加入我们": "Tham gia cùng chúng tôi",
  "月入百万": "Thu nhập hàng tháng lên đến một triệu",
  "NG扑克": "NG Poker",
  "活动中心": "Trung tâm hoạt động",
  "平台优惠回馈活动": "Chương trình khuyến mãi ưu đãi của nền tảng",
  "输赢比例": "Tỷ lệ thắng thua",
  "功能设置": "Cài đặt chức năng",
  "反水比例": "Tỷ lệ nước ngược",
  "反水中心": "Trung tâm chống nước",
  "修改登录密码": "Thay đổi mật khẩu đăng nhập",
  "个人资料": "Thông tin cá nhân",
  "个人头像": "Hình đại diện cá nhân",
  "用户名": "Tên người dùng",
  "请输入用户名": "Tên người dùng",
  "请输入真实姓名": "Tên thật",
  "出生日期": "Ngày sinh",
  "请选择出入日期": "Ngày sinh",
  "手机号码": "Số điện thoại di động",
  "绑定手机号保障账号安全": "Đăng ký số điện thoại di động để bảo vệ tài khoản an toàn",
  "电子邮箱": "Email",
  "绑定邮箱保护账号安全": "Bind email to protect account security",
  "请输入正确手机号": "Vui lòng nhập số điện thoại di động chính xác",
  "请输入正确邮箱号": "Vui lòng nhập địa chỉ email chính xác",
  "请输入正确的日期格式": "Vui lòng nhập định dạng ngày tháng chính xác.",
  "邀请链接": "Liên kết mời",
  "立即邀请": "Mời ngay lập tức",
  "礼金介绍": "Giới thiệu về tiền mừng",
  "明细记录": "Chi tiết ghi chép",
  "下级概览": "Tổng quan cấp dưới",
  "下级成员统计": "Thống kê thành viên cấp dưới",
  "本月新增": "Thêm mới trong tháng này",
  "本月活跃成员": "Thành viên hoạt động trong tháng này",
  "本月有效活跃": "Hoạt động hiệu quả trong tháng này",
  "今日新增": "Hôm nay có thêm",
  "今日活跃": "Hoạt động hôm nay",
  "本月新增有效会员": "Thành viên mới có hiệu lực trong tháng này",
  "今日存款": "Tiền gửi hôm nay",
  "数据列表": "Danh sách dữ liệu",
  "礼金记录": "Ghi chép tiền mừng",
  "好友明细": "Chi tiết bạn bè",
  "重置": "Đặt lại",
  "查询": "truy vấn",
  "日期": "Ngày",
  "礼金": "tiền mừng",
  "备注": "Ghi chú",
  "保存链接": "Lưu liên kết",
  "保存图片": "Lưu hình ảnh",
  "保存二维码": "Lưu mã QR",
  "取消": "Hủy bỏ",
  "链接已复制到剪贴板": "Liên kết đã được sao chép vào khay nhớ tạm",
  "复制链接失败": "Sao chép liên kết không thành công",
  "合营部": "Phòng Hợp tác",
  "立即咨询": "Liên hệ ngay",
  "咨询": "Tư vấn",
  "联系方式": "Thông tin liên hệ",
  "请输入您的联系方式": "Thông tin liên hệ",
  "申请理由": "Lý do nộp đơn",
  "请输入申请理由": "Lý do nộp đơn",
  "盈利总额": "Tổng lợi nhuận",
  "充值总额": "Tổng số tiền nạp",
  "提现总额": "Tổng số tiền rút",
  "投注总额": "Tổng số tiền đặt cược",
  "设置": "Cài đặt",
  "消息时间显示": "Thời gian hiển thị tin nhắn",
  "中奖提示": "Thông báo trúng thưởng",
  "安静模式": "Chế độ im lặng",
  "关于CG": "Về CG",
  "帮助与反馈": "Trợ giúp và phản hồi",
  "退出": "Thoát",
  "返水比例": "Tỷ lệ hoàn lại tiền",
  "当日累计投注": "Tổng số tiền cược trong ngày",
  "转运金": "Chuyển tiền",
  "开元棋牌": "Kaiyuan Chess",
  "设置提现密码": "Đặt mật khẩu rút tiền",
  "原密码": "Mật khẩu gốc",
  "请输入当前密码": "Mật khẩu hiện tại",
  "新密码": "Mật khẩu mới",
  "请输入新密码": "Vui lòng nhập mật khẩu mới",
  "确认新密码": "Xác nhận mật khẩu mới",
  "请再次输入密码": "Vui lòng nhập lại mật khẩu",
  "请输入旧密码": "Vui lòng nhập mật khẩu cũ",
  "请输入正确的旧密码长度": "Vui lòng nhập độ dài mật khẩu cũ chính xác",
  "请输入正确的新密码长度": "Vui lòng nhập độ dài mật khẩu mới chính xác",
  "两次密码不一致": "Hai lần mật khẩu không khớp nhau",
  "新旧密码不能一致": "Mật khẩu cũ và mới không được giống nhau.",
  "密码修改成功": "Mật khẩu đã được thay đổi thành công",
  "app下载": "Tải ứng dụng",
  "可扫描下发二维码进行app下载": "Quét mã QR để tải ứng dụng",
  "立即下载": "Tải xuống ngay",
  "下载说明": "Cần tải xuống, cài đặt và đăng ký trong cùng một môi trường mạng, vui lòng không chuyển đổi mạng; Nếu không thể cài đặt bình thường, vui lòng sử dụng trình duyệt có sẵn trên điện thoại để mở trang này.",
  "请输入金额": "Vui lòng nhập số tiền",
  "转入": "Chuyển vào",
  "平台钱包": "ví điện tử",
  "操作金额不能为0": "Số tiền giao dịch không được là 0",
  "转入成功": "Chuyển thành công",
  "天": "trời",
  "时": "thời",
  "分": "phân",
  "秒": "giây",
  "剩余领取次数": "Số lần nhận còn lại",
  "次": "lần sau",
  "主账号余额": "Số dư tài khoản chính",
  "账户充值": "Nạp tiền vào tài khoản",
  "账户提现": "Rút tiền từ tài khoản",
  "下线转账": "Chuyển khoản ngoại tuyến",
  "订单号": "Số đơn hàng",
  "金额": "Số tiền",
  "空空如也": "trống rỗng",
  "今日": "Hôm nay",
  "近7日": "Gần 7 ngày",
  "近15日": "Gần 15 ngày",
  "近30日": "Gần 30 ngày",
  "转出": "Chuyển ra",
  "赠送": "Tặng",
  "反水": "phản bội",
  "未定义": "Chưa xác định",
  "待审核": "Chờ duyệt",
  "审核通过": "Đã duyệt",
  "审核拒绝": "Từ chối phê duyệt",
  "失败": "thất bại",
  "成功": "thành công",
  "待结算": "Chờ thanh toán",
  "全平台": "Tất cả các nền tảng",
  "大舞台": "Sân khấu lớn",
  "官方动态": "Thông tin chính thức",
  "动态": "Động thái",
  "活动申请记录": "Hồ sơ đăng ký hoạt động",
  "活动标题": "Tiêu đề hoạt động",
  "申请时间": "Thời gian nộp đơn",
  "状态": "Trạng thái",
  "未约定": "Không có thỏa thuận",
  "通过": "Thông qua",
  "拒绝": "từ chối",
  "派彩": "phát thưởng",
  "无效注单": "Phiếu đặt hàng không hợp lệ",
  "已结算": "Đã thanh toán",
  "未结算": "Chưa thanh toán",
  "返水中心": "Trung tâm hoàn tiền",
  "返水记录": "Lịch sử hoàn tiền",
  "点击领取": "Nhấp để nhận",
  "累计领取": "Tổng số tiền đã nhận",
  "待领取": "Chờ nhận",
  "返水金额": "Số tiền hoàn lại",
  "返水时间": "Thời gian hoàn tiền",
  "领取时间": "Thời gian nhận",
  "暂未领取": "Chưa nhận",
  "暂无领取额度": "Chưa nhận",
  "加载中": "đang tải",
  "最多支持添加5个地址": "Hỗ trợ thêm tối đa 5 địa chỉ",
  "认证失败": "Xác thực không thành công",
  "您的账号登陆过期，请重新登陆": "Tài khoản đăng nhập của bạn đã hết hạn, vui lòng đăng nhập lại",
  "提示": "gợi ý",
  "您确定要退出登录吗": "Bạn có chắc chắn muốn đăng xuất không",
  "精彩内容等你来体验，快来登录吧": "Nội dung tuyệt vời đang chờ bạn trải nghiệm, hãy đến và đăng nhập",
  "立即下载APP": "Tải APP Ngay",
  "余额": "THĂNG BẰNG",

  "活动详情": "Chi tiết sự kiện",
  "活动说明": "Mô tả hoạt động",
  "立即申请": "Đăng ký ngay bây giờ",
  "前往登录": "Đi đến đăng nhập",

  "代理系统": "hệ thống đại lý",
  "下属代理": "Phụ thuộc đại lý",
  "代理总览": "Phụ thuộc đại lý",
  "直属玩家": "Người chơi trực thuộc",
  "盈亏统计": "Thống kê lãi lỗ",
  "账单查询": "Tra cứu hóa đơn",
  "充值记录": "Lịch sử nạp tiền",
  "提现记录": "Lịch sử rút tiền",
  "个人信息": "Thông tin cá nhân",
  "下级在线": "Thành viên cấp dưới trực tuyến",
  "我的余额": "Số dư của tôi",
  "附属代理人": "Đại lý phụ thuộc",
  "附属玩家": "Người chơi trực thuộc",
  "今日投注": "Đặt cược hôm nay",
  "今日收入": "Thu nhập hôm nay",
  "历史收入": "Lịch sử thu nhập",
  "邀请码": "Mã mời",

  "开盘中": "Đang mở phiên",
  "已封盘": "Đã đóng phiên",
  "下注倒计时": "Đếm ngược đặt cược",
  "期": "Kỳ",
  "期开奖结果": "Kết quả xổ số",
  "已开启": "Đã mở",
  "已关闭": "Đã đóng",
  "期号": "Số kỳ",
  "号码": "Số",
  "总和": "Tổng hợp",
  "总和两面": "Tổng hợp hai mặt",
  "首页": "Trang đầu",
  "上一页": "Trang trước",
  "下一页": "Trang sau",
  "尾页": "Trang cuối",
  "请输入": "Vui lòng nhập",
  "下注": "Đặt cược",
  "选择": "Chọn",
  "大小单双": "Tài xỉu chẵn lẻ",
  "大": "Tài",
  "小": "Xỉu",
  "单": "Lẻ",
  "双": "Chẵn",
  "大单": "Tài lẻ",
  "大双": "Tài chẵn",
  "小单": "Xỉu lẻ",
  "小双": "Xỉu chẵn",
  "形态": "Hình thái",
  "豹子": "Báo tử",
  "对子": "Đôi",
  "顺子": "Thẳng",
  "极大": "Cực tài",
  "极小": "Cực xỉu",
  "特码": "Đặc mã",
  "清空": "Xóa hết",
  "立即下注": "Đặt cược ngay",
  "开奖号码": "Số mở thưởng",
  "第": "Thứ",
  "投注时间": "Thời gian đặt cược",
  "投注金额": "Số tiền đặt cược",
  "玩法": "Cách chơi",
  "盘类": "Loại cược",
  "派奖奖金": "Thưởng phát thưởng",
  "赔率": "Tỷ lệ cược",
  "双面玩法": "Cược hai mặt",
  "特码玩法": "Cược số đặc biệt",
  "倍": "lần",
  "投注积分": "Điểm cược",
  "请输入投注积分": "Vui lòng nhập điểm cược",
  "返水": "Hoa hồng hoàn trả",
  "总投注": "Tổng cược",
  "有效投注": "Cược hợp lệ",
  "实际盈利": "Lợi nhuận thực tế",
  "两面": "Hai mặt",
  "组合": "Kết hợp",
  "每页": "Mỗi trang",
  "条": "Mục",
  "编辑金额": "Chỉnh sửa số tiền",
  "恢复默认": "Phục hồi mặc định",
  "保存": "Lưu",
  "距离开奖": "Cách thời gian mở thưởng",
  "刷新": "Làm mới",
  "返回": "Quay lại",
  "当前第": "Hiện tại thứ",
  "数据统计详情": "Chi tiết thống kê dữ liệu",
  "值": "Giá trị",
  "未开期数": "Số kỳ chưa mở",
  "单路区": "Khu một đường",
  "间隔": "Khoảng cách",
  "咪牌": "Xem bài",

  "投注区": "Khu vực đặt cược",
  "游戏记录": "Lịch sử trò chơi",
  "路单区": "Khu lộ trình",
  "游戏规则": "Luật chơi",
  "开奖验证": "Xác minh kết quả",
  "开奖记录": "Lịch sử mở thưởng",
  "统计": "Thống kê",
  "大小": "Tài Xỉu",
  "极大小": "Cực Tài Xỉu",
  "已选": "Đã chọn",
  "注": "Cược",
  "共计": "Tổng cộng",
  "已中奖": "Đã trúng thưởng",
  "未开奖": "Chưa mở thưởng",
  "已退款": "Đã hoàn tiền",
  "语言": "ngôn ngữ",

  "六合彩": "Xổ số Hồng Kông",
  "初级": "Cấp cơ bản",
  "猜特码": "Đoán số đặc biệt",
  "猜特肖": "Đoán con giáp đặc biệt",
  "猜平肖": "Đoán con giáp bình thường",
  "猜类型": "Đoán loại hình",
  "平肖": "Con giáp bình thường",
  "鼠": "Tý",
  "牛": "Sửu",
  "虎": "Dần",
  "兔": "Mão",
  "龙": "Thìn",
  "蛇": "Tỵ",
  "马": "Ngọ",
  "羊": "Mùi",
  "猴": "Thân",
  "鸡": "Dậu",
  "狗": "Tuất",
  "猪": "Hợi",
  "类型": "Loại hình",
  "蓝波": "Sóng xanh",
  "绿波": "Sóng lục",
  "红波": "Sóng đỏ",
  "特肖": "Con giáp đặc biệt",
  "特鼠": "Chuột đặc biệt",
  "特牛": "Trâu đặc biệt",
  "特虎": "Hổ đặc biệt",
  "特兔": "Thỏ đặc biệt",
  "特龙": "Rồng đặc biệt",
  "特蛇": "Rắn đặc biệt",
  "特马": "Ngựa đặc biệt",
  "特羊": "Dê đặc biệt",
  "特鸡": "Gà đặc biệt",
  "特狗": "Chó đặc biệt",
  "特猪": "Heo đặc biệt",
  "特猴": "Chú khỉ đặc biệt",
  "什么也没有": "Không có gì cả",
  "进行中": "Đang diễn ra",
  "已结束": "Đã kết thúc",
  "快捷下注": "Đặt cược nhanh",
  "开奖走势": "Xu hướng mở thưởng",
  "开奖历史": "Lịch sử mở thưởng",
  "在线": "Trực tuyến",
  "快捷投注": "Đặt cược nhanh",
  "项": "Hạng mục",
  "需支付": "Cần thanh toán",
  "确认投注": "Xác nhận cược",
  "错误提示": "Thông báo lỗi",
  "管理员": "quản trị viên",
  "封盘中": "Đã đóng",
  "预计盈利": "lợi nhuận dự kiến",
  "投注成功": "Đặt cược thành công",
  "用户": "Người dùng",
  "时间": "Thời gian",
  "投注": "Đặt cược",
  "MI28": "MI28",
  "中级": "Trung cấp",
  "新澳门六合彩": "Xổ số Hồng Kông Ma Cao Mới",
  "澳门六合彩": "Xổ số Hồng Kông Ma Cao",
  "下注内容": "Nội dung cược",
  "合计总金额": "Tổng số tiền",
  "房间": "Phòng",
  "投注详情": "Chi tiết cược",
  "输赢": "Thắng/Thua",
  "开奖结果": "Kết quả mở thưởng",
  "当期总输赢": "Thắng/Thua kỳ này",
  "开奖时间": "Thời gian mở thưởng",
  "更多新玩法等你来体验": "Nhiều cách chơi mới đang chờ bạn trải nghiệm",
  "精彩活动": "Hoạt động hấp dẫn",
  "代理联盟": "Liên minh đại lý",
  "始于成功": "Bắt đầu từ thành công",
  "臻于卓越": "Vươn tới xuất sắc",
  "鲤跃龙门": "Cá chép vượt vũ môn",
  "投资传奇": "Huyền thoại đầu tư",
  "VIP会员成长": "Tăng trưởng thành viên VIP",
  "晋级VIP会员": "Thăng hạng thành viên VIP",
  "享顶级至尊服务": "Tận hưởng dịch vụ hàng đầu",
  "确认添加": "Xác nhận thêm",
  "iOS用户注意": "Lưu ý người dùng iOS",
  "充值打码量": "Yêu cầu doanh số cược nạp tiền",
  "全部": "Tất cả",
  "划转": "Chuyển khoản",
  "协议的区别": "Sự khác biệt giữa các giao thức",
  "开奖中": "Đang mở thưởng",
  "新增USDT地址": "Thêm địa chỉ USDT",
  "新增银行卡": "Thêm thẻ ngân hàng",
  "本月存款": "Tiền nạp trong tháng này",
  "游戏大厅": "Sảnh trò chơi",
  "玩法介绍": "Hướng dẫn chơi",
  "账户": "Tài khoản",
  "赠送打码量": "Doanh số cược được tặng",
  "搜索游戏名称": "Tìm kiếm trò chơi",
  "请登录": "Vui lòng đăng nhập",
  "红包已关闭": "Hồng bao đã đóng",
  "已在当前页面": "Đã ở trang hiện tại",
  "马克六号彩票": "Xổ số Mark Six",
  "PC28高赔率": "MI28 tỷ lệ cao",
  "PC28": "MI28",
  "发送的消息不能为空": "发送的消息不能为空",
  "19:56:30～20:29:30 为维护时间": "19:56:30～20:29:30 为维护时间",
  "23:55:30～00:05:00 为维护时间": "23:55:30～00:05:00 为维护时间",
  "本期已封盘": "本期已封盘",
  "发送成功": "发送成功",
  "请选择玩法": "请选择玩法",
  "请选择金额": "请选择金额",
  "恢复成功": "恢复成功",
  "价格不能为空值或0": "价格不能为空值或0",
  "价格不能有重复": "价格不能有重复",
  "持卡人姓名": "持卡人姓名",
  "请输入持卡人姓名": "请输入持卡人姓名",
  "为了您的资金能够迅速到账，请确保填写的姓名与银行卡的开户姓名一致": "为了您的资金能够迅速到账，请确保填写的姓名与银行卡的开户姓名一致",
  "请选择银行类型": "请选择银行类型",
  "请输入开户行": "请输入开户行",
  "请输入姓名": "请输入姓名",
  "请输入银行": "请输入银行",
  "请输人银行卡号": "请输人银行卡号",
  "请输人支付密码": "请输人支付密码",
  "请输人正确的卡号长度": "请输人正确的卡号长度",
  "请输人支付密码长度": "请输人支付密码长度",
  "绑定成功": "绑定成功",
  "USDT地址": "USDT地址",
  "请输入USDT地址": "请输入USDT地址",
  "请选择钱包协议": "请选择钱包协议",
  "赠送记录": "赠送记录",
  "选择开始日期": "选择开始日期",
  "选择结束日期": "选择结束日期",
  "输入账号": "输入账号",
  "昵称": "昵称",
  "赠送前": "赠送前",
  "赠送后": "赠送后",
  "赠送金额": "赠送金额",
  "到账状态": "到账状态",
  "直属代理": "直属代理",
  "自己": "自己",
  "请先选择开始时间": "请先选择开始时间",
  "团队总人数": "团队总人数",
  "团队总彩金": "团队总彩金",
  "团队总充值": "团队总充值",
  "团队总输赢": "团队总输赢",
  "团队总投注": "团队总投注",
  "团队纯利": "团队纯利",
  "团队福利": "团队福利",
  "新注册人数": "新注册人数",
  "首充人数": "首充人数",
  "团队返水": "团队返水",
  "团队拥金返水": "团队拥金返水",
  "六合盈亏": "六合盈亏",
  "金币": "金币",
  "总盈利": "Tổng lợi nhuận",
  "直属": "直属",
  "所在房间": "所在房间",
  "代理": "代理",
  "暂无数据": "暂无数据",
  "MI28按照加拿大卑斯快乐8的开奖结果为基础": "MI28按照加拿大卑斯快乐8的开奖结果为基础",
  "每日官网维护时间是18:56-19:33": "每日官网维护时间是18:56-19:33",
  "每3.5分钟公布一次加拿大卑斯快乐8开奖结果": "每3.5分钟公布一次加拿大卑斯快乐8开奖结果",
  "排序后分别按号码": "排序后分别按号码",
  "第1-6，7-12，13-18分为【1】【2】【3】三个区": "第1-6，7-12，13-18分为【1】【2】【3】三个区",
  "赔率全新升级！ 单注1起，总注500000封顶。大小单双100000封顶。组合50000封顶。": "赔率全新升级！ 单注1起，总注500000封顶。大小单双100000封顶。组合50000封顶。",
  "特码20000封顶。2值10000封顶。 大小单双2.0倍（含本金）。【组合:小单/大双4.6倍；小双/大单4.2倍】（含本金）。": "特码20000封顶。2值10000封顶。 大小单双2.0倍（含本金）。【组合:小单/大双4.6倍；小双/大单4.2倍】（含本金）。",
  "注：大小单双开13/14特殊赔率": "注：大小单双开13/14特殊赔率",
  "总注：4999以内1.6倍（含本金）": "总注：4999以内1.6倍（含本金）",
  "总注：9999以内1.2倍（含本金）": "总注：9999以内1.2倍（含本金）",
  "总注：30000以上吃下注本金": "总注：30000以上吃下注本金",
  "组合：29999以内小单，大双 开13，14赔率回本（含本金）！": "组合：29999以内小单，大双 开13，14赔率回本（含本金）！",
  "组合：30000以上吃下注本金": "组合：30000以上吃下注本金",
  "豹子-顺子-对子-玩法": "豹子-顺子-对子-玩法",
  "豹子48倍": "豹子48倍",
  "顺子10倍": "顺子10倍",
  "对子3倍": "对子3倍",
  "极值15倍": "极值15倍",
  "回水规则": "回水规则",
  "1、负分3600.000-36000.000 需下注把数10吧 反百分之3": "1、负分3600.000-36000.000 需下注把数10吧 反百分之3",
  "2、负分36000.000-100000.000需下注把数10把 反百分之5": "2、负分36000.000-100000.000需下注把数10把 反百分之5",
  "3、负分100000.000需下注把数10把 反百分之8": "3、负分100000.000需下注把数10把 反百分之8",
  "【MI28】规则说明": "【MI28】规则说明",
  "1.大小玩法 数字14-27为大 数字0-13为小 。": "1.大小玩法 数字14-27为大 数字0-13为小 。",
  "2.单双玩法": "2.单双玩法",
  "数字1，3，5，~27为单 数字0，2，4~26为双。": "数字1，3，5，~27为单 数字0，2，4~26为双。",
  "3.极值玩法": "3.极值玩法",
  "极小：0，1，2，3，4，5": "极小：0，1，2，3，4，5",
  "极大：22，23，24，25，26，27": "极大：22，23，24，25，26，27",
  "举例：买极小 开奖结果为0-5其中一个数字就中奖，买极大开奖结果为22-27其中一个数字就中奖。": "举例：买极小 开奖结果为0-5其中一个数字就中奖，买极大开奖结果为22-27其中一个数字就中奖。",
  "4.组合玩法": "4.组合玩法",
  "* 数字14，16，~26为大双； 数字0，2，4，~12为小双。": "* 数字14，16，~26为大双； 数字0，2，4，~12为小双。",
  "* 数字15，17，~27为大单； 数字1，3，5，~13为小单。": "* 数字15，17，~27为大单； 数字1，3，5，~13为小单。",
  "5.定位玩法(单点数字玩法)": "5.定位玩法(单点数字玩法)",
  "从数字0-27中选取一个数字下注，如选取下注的数字与开奖如果相同，即为中奖。": "从数字0-27中选取一个数字下注，如选取下注的数字与开奖如果相同，即为中奖。",
  "6.波色": "6.波色",
  "* 绿波号码：1 , 4 , 7 , 10 , 16 , 19 , 22 , 25": "* 绿波号码：1 , 4 , 7 , 10 , 16 , 19 , 22 , 25",
  "* 蓝波号码：2 , 5 , 8 , 11 , 17 , 20 , 23 , 26": "* 蓝波号码：2 , 5 , 8 , 11 , 17 , 20 , 23 , 26",
  "* 红波号码：3 , 6 , 9 , 12 , 15 , 18 , 21 , 24": "* 红波号码：3 , 6 , 9 , 12 , 15 , 18 , 21 , 24",
  "* 当开奖结果为：0,13,14,27(所有买的波色皆输)视为全部不中奖！": "* 当开奖结果为：0,13,14,27(所有买的波色皆输)视为全部不中奖！",
  "7.豹子  顺子  对子": "7.豹子  顺子  对子",
  "当期3个开奖号码一致则中奖 , 如当期开奖结果为 3+3+3=9 则中奖豹子。": "当期3个开奖号码一致则中奖 , 如当期开奖结果为 3+3+3=9 则中奖豹子。",
  "当期3个开奖号码顺子则中奖，如当期开奖结果为 1+2+3=6 则中奖顺子。": "当期3个开奖号码顺子则中奖，如当期开奖结果为 1+2+3=6 则中奖顺子。",
  "当期3个开奖号码有两个一致中奖，如当期开奖结果为 0+2+2=4 则中奖对子。": "当期3个开奖号码有两个一致中奖，如当期开奖结果为 0+2+2=4 则中奖对子。",
  "已经是最后一页啦！": "已经是最后一页啦！",
  "用户名长度6~16位，以字母或数字组合！": "用户名长度6~16位，以字母或数字组合！",
  "请输入正确的密码长度，最少6位！": "请输入正确的密码长度，最少6位！",
  "密码错误，请重新输入": "密码错误，请重新输入",
  "账户登录": "账户登录",
  "请输入账号": "请输入账号",
  "验证码": "验证码",
  "记住密码": "记住密码",
  "跳过登录，先去逛逛": "跳过登录，先去逛逛",
  "新用户注册": "新用户注册",
  "请输入短信验证码": "请输入短信验证码",
  "获取验证码": "获取验证码",
  "切换线路": "切换线路",
  "请输入您的账号和密码！": "请输入您的账号和密码！",
  "OB电子": "OB电子",
  "FG电子": "FG电子",
  "PP电子": "PP电子",
  "AE电子": "AE电子",
  "始": "始",
  "开": "开",
  "包": "包",
  "红": "红",
  "离": "离",
  "距": "距",
  "束": "束",
  "结": "结",
  "完": "完",
  "抢": "抢",
  "已": "已",
  "已领取": "已领取",
  "当前最多可领取": "当前最多可领取",
  "快去满足条件吧！": "快去满足条件吧！",
  "活动时间": "活动时间",
  "累计充值金额": "累计充值金额",
  "红包次数": "红包次数",
  "领取规则": "领取规则",
  "抢到红包后，系统自动派彩，": "抢到红包后，系统自动派彩，",
  "秒到账": "秒到账",
  "，达到流水倍数即可取款；": "，达到流水倍数即可取款；",
  "2.领取红包条件：充值金额需要在规定的活动日期（美东时间）范围内，根据充值累计金额，获取抢红包次数，即可抢对应次数的红包；": "2.领取红包条件：充值金额需要在规定的活动日期（美东时间）范围内，根据充值累计金额，获取抢红包次数，即可抢对应次数的红包；",
  "南宫集团官网": "南宫集团官网",
  "注意": "注意",
  "抢红包": "抢红包",
  "北京时间为每天早上10点到12点，存款计算为前一天12点到今天10点，谢谢~": "北京时间为每天早上10点到12点，存款计算为前一天12点到今天10点，谢谢~",
  "每日百万现金红包！存款越多，机会越多，红包享不停，惊喜抢不停，还等什么？快快叫上好友一起分享吧！！": "每日百万现金红包！存款越多，机会越多，红包享不停，惊喜抢不停，还等什么？快快叫上好友一起分享吧！！",
  "1、会员必须在指定的活动日期（美东时间）范围内，根据充值累计金额，即可获得对应抢红包次数。若在规定的时间范围内没有达到存款金额范围，则不计算抢红包次数，逾期作废！": "1、会员必须在指定的活动日期（美东时间）范围内，根据充值累计金额，即可获得对应抢红包次数。若在规定的时间范围内没有达到存款金额范围，则不计算抢红包次数，逾期作废！",
  "2、所有的活动优惠特为玩家而设，如发现任何团体或个人，以不诚实的方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余的权利。": "2、所有的活动优惠特为玩家而设，如发现任何团体或个人，以不诚实的方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余的权利。",
  "3、金沙集团官网保留所有解释权，在任何时候都可以更改、停止、取消优惠活动。": "3、金沙集团官网保留所有解释权，在任何时候都可以更改、停止、取消优惠活动。",
  "当前时间段": "当前时间段",
  "活动还没开始，请静待活动开始。": "活动还没开始，请静待活动开始。",
  "请静待下次活动。": "请静待下次活动。",
  "恭喜您": "恭喜您",
  "抢到": "抢到",
  "立即充值": "立即充值",
  "您暂未达到领取条件，快去完成吧！": "您暂未达到领取条件，快去完成吧！",
  "服务器异常，请稍后再试": "服务器异常，请稍后再试",
  "软件APP": "软件APP",
  "按照": "按照",
  "到您的桌面": "到您的桌面",
  "安装": "安装",
  "请先登录": "请先登录",
  "PC彩票": "PC彩票",
  "万美元": "万美元",
  "现在就成为赢家": "现在就成为赢家",
  "开始": "开始",
  "最新投注": "最新投注",
  "最新": "Mới nhất",
  "日榜": "Hàng ngày",
  "周榜": "Hàng tuần",
  "月榜": "Hàng tháng",
  "经典": "Cổ điển",
  "百家乐": "Baccarat",
  "快速": "Nhanh",
  "大富翁": "Monopoly",
  "财神驾到": "Thần Tài đến",
  "红包派对": "Tiệc lì xì",
  "沙巴体育": "Thể thao Saba",
  "UP体育": "Thể thao UP",
  "德州扑克": "Poker Texas",
  "21点": "Blackjack",
  "抢庄牛牛": "Bò tót",
  "巴沙体育": "Thể thao Basha",
  "游戏": "游戏",
  "玩家": "玩家",
  "倍数": "倍数",
  "返奖": "返奖",
  "更多": "更多",
  "热门": "热门",
  "即将上线，敬请期待": "即将上线，敬请期待",
  "立即投注": "立即投注",
  "游戏厂商": "游戏厂商",
  "183款游戏": "183款游戏",
  "千人在线畅玩": "千人在线畅玩",
  "最佳加密货币赌场 - 欢迎来到": "最佳加密货币赌场 - 欢迎来到",
  "home-detail-content": "Khám phá điểm đến tuyệt vời nhất cho trò chơi tiền mã hóa. Mọi giao dịch tại đây đều minh bạch, công khai và tính công bằng của mọi trò chơi đều có thể được xác minh. • Casino MI28 cam kết mang đến môi trường trò chơi an toàn, đáng tin cậy và công bằng cho mọi người dùng.",
  "收起更多": "收起更多",
  "查看更多": "查看更多",
  "支持/法律": "支持/法律",
  "常见问题": "常见问题",
  "负责任博彩": "负责任博彩",
  "公平公正": "公平公正",
  "服务条款": "服务条款",
  "隐私政策": "隐私政策",
  "关于我们": "关于我们",
  "支持的币种": "支持的币种",
  "赞助和博彩责任": "赞助和博彩责任",
  "introduce1": "MI28 do BETMGM LLC sở hữu và vận hành. Công ty được đăng ký tại bang Delaware, Hoa Kỳ, mã số 7061304, địa chỉ đăng ký tại Marina District, Atlantic City, New Jersey, Hoa Kỳ, và phát triển hoạt động trực tuyến dựa trên các nguồn lực ngoại tuyến của MGM Resorts.",
  "introduce2": "BetMGM sở hữu giấy phép kinh doanh cá cược chính thức tại nhiều bang của Hoa Kỳ và các khu vực ở nước ngoài. Một số giấy phép cốt lõi có thể được tra cứu công khai như sau:",
  "introduce3": "New Jersey: Do Cơ quan Thực thi Cờ bạc New Jersey cấp, số giấy phép NJIGP 000105-001, là một trong những giấy phép vận hành cốt lõi đầu tiên của BetMGM.",
  "introduce4": "Nevada: Do Ủy ban Kiểm soát Cờ bạc Nevada cấp, sở hữu giấy phép cá cược thể thao toàn diện.",
  "introduce5": "Vương quốc Anh: Sở hữu giấy phép cờ bạc từ xa do Ủy ban Cờ bạc Vương quốc Anh (UK Gambling Commission) cấp, số giấy phép 042596.",
  "introduce6": "MI28 cam kết cung cấp môi trường trò chơi an toàn, đáng tin cậy và công bằng cho tất cả người dùng. Dù đặt cược, chơi máy đánh bạc hay tham gia các trò chơi trực tiếp và trò chơi khác, bạn có thể yên tâm rằng MI28 hoạt động chính trực và mang đến trải nghiệm tuyệt vời cho mọi người chơi.",
  "尊敬的NG娱乐会员:": "尊敬的NG娱乐会员:",
  "我知道了": "我知道了",
  "如何安装": "如何安装",
  "1、使用Safar浏览器打开网站": "1、使用Safar浏览器打开网站",
  "2、点击分享图标": "2、点击分享图标",
  "3、选择“添加到主屏幕”": "3、选择“添加到主屏幕”",
  "添加到主屏幕": "添加到主屏幕",
  "期开奖": "期开奖",
  "账户余额": "账户余额",
  "封盘中禁止投注": "封盘中禁止投注",
  "请输入文字指令下注": "请输入文字指令下注",
  "发送": "发送",
  "信用投注": "信用投注",
  "共": "共",
  "合计": "合计",
  "最近投注": "最近投注",
  "投注确认": "投注确认",
  "游戏平台": "游戏平台",
  "免转模式": "免转模式",
  "额度转换": "额度转换",
  "平台账户余额": "平台账户余额",
  "游戏账户余额": "游戏账户余额",
  "操作金额": "操作金额",
  "填写操作金额": "填写操作金额",
  "转账方式": "转账方式",
  "提交": "提交",
  "充值信息": "充值信息",
  "请在": "请在",
  "内完成支付": "内完成支付",
  "成功付款后，将自动到账！": "成功付款后，将自动到账！",
  "如有问题，请": "如有问题，请",
  "确认": "确认",
  "收款地址": "收款地址",
  "交易时间": "交易时间",
  "充值方式": "充值方式",
  "充值完成": "充值完成",
  "资金明细": "资金明细",
  "支付方式": "支付方式",
  "银行卡": "银行卡",
  "余额充值": "余额充值",
  "请输入充值金额": "请输入充值金额",
  "充值限额：": "充值限额：",
  "请设置密码": "请设置密码",
  "注册并下载APP": "注册并下载APP",
  "两次密码不一样！": "两次密码不一样！",
  "请输入验证码！": "请输入验证码！",
  "验证码错误！": "验证码错误！",
  "注册失败": "注册失败",
  "获取验证码...": "获取验证码...",
  "请阅读并同意相关条款和隐私协议！": "请阅读并同意相关条款和隐私协议！",
  "两次密码不一致！": "两次密码不一致！",
  "请输入您的真实姓名!": "请输入您的真实姓名!",
  "请输入正确的支付密码长度，最少6位！": "请输入正确的支付密码长度，最少6位！",
  "卡片管理": "卡片管理",
  "虚拟币": "虚拟币",
  "最多支持添加5张银行卡": "最多支持添加5张银行卡",
  "确定要解除绑定该卡片吗？": "确定要解除绑定该卡片吗？",
  "解绑成功": "解绑成功",

  "(几分钟到数十分钟)": "(several minutes to tens of minutes)",
  "(几秒到几分钟)": "(a few seconds to a few minutes)",
  "*两种协议对应的USDT地址不互通，进行转账、充值等操作时，应仔细核对正确地址！": "*USDT addresses for the two protocols are not interchangeable. Verify the address before transferring or depositing.",
  "1. 点击我的 (个人信息)": "1. Tap My (Personal information)",
  "1.第一次提现到数字货币时，请先绑定提币地址，绑定提币地址的步骤：": "1. Before your first crypto withdrawal, bind a withdrawal address:",
  "1.请注意，注册时要求填写真实而准确的信息。": "1. Please provide true and accurate information when registering.",
  "2. 卡片管理": "2. Card management",
  "2.用户使用网站前，请务必先阅读规则与条款，并确定已年满18岁。": "2. Read the rules and terms and confirm that you are at least 18 before using the site.",
  "2.输入提币金额，点击‘立即取款’，提币申请提交成功": "2. Enter the withdrawal amount and tap “Withdraw now” to submit the request.",
  "2007-08赛季，尼克·杨代表奇才队出战75场常规赛比赛，场均得到7.5分、1.5个篮板。": "In the 2007–08 season, Nick Young played 75 regular-season games for Washington, averaging 7.5 points and 1.5 rebounds.",
  "2007年NBA选秀，尼克·杨在第一轮第16顺位被华盛顿奇才队选中。": "Nick Young was selected 16th overall by Washington in the first round of the 2007 NBA Draft.",
  "2008-09赛季，由于奇才后场大将吉尔伯特·阿里纳斯的报销，尼克·杨获得了更多的机会，出战82场首发5次，场均得到10.9分。": "In 2008–09, Nick Young received more opportunities after Gilbert Arenas was sidelined, appearing in 82 games with five starts and averaging 10.9 points.",
  "2009-10赛季，奇才后场补充了兰迪·弗耶、迈克·米勒等优秀球员，抢占了尼克·杨的出场时间，尼克·杨出战74场比赛，场均得到8.6分": "In 2009–10, Washington added Randy Foye and Mike Miller, reducing Young’s playing time; he appeared in 74 games and averaged 8.6 points.",
  "3. 添加虚拟币地址": "3. Add a cryptocurrency address",
  "3.提币审核成功后请登录交易网站或数字货币官方网站核实到账金额": "3. After approval, check the credited amount on your exchange or the official cryptocurrency site.",
  "4. 填写虚拟币地址信息": "4. Enter the cryptocurrency address information",
  "5. 选择虚拟币提现/立即取款": "5. Select cryptocurrency withdrawal / Withdraw now",
  "6. 等待审核": "6. Wait for review",
  "ERC20-USDT地址以0x开头": "ERC20 USDT addresses start with 0x",
  "ERC20协议": "ERC20 protocol",
  "ERC20：基于以太坊网络协议": "ERC20: based on the Ethereum network protocol",
  "Hi，欢迎进入{title}": "Hi, welcome to {title}",
  "TRC20-USDT地址以T开头": "TRC20 USDT addresses start with T",
  "TRC20协议": "TRC20 protocol",
  "TRC20的提币手续费最低，这意味着用户可以享受低手续费的交易所提币服务。同时，波场网络的TPS能够达到上千级别，可以实现交易秒级确认。": "TRC20 has the lowest withdrawal fee. Its high network throughput can confirm transactions in seconds.",
  "TRC20：基于波场网络协议": "TRC20: based on the TRON network protocol",
  "Luka赞助内容": "In June 2019, Luka Doncic partnered with {title} as an official ambassador. Together, {title} and Luka Doncic aim to build a new global sports leader.",
  "专属VIP体验": "Exclusive VIP experience",
  "个人简介": "Profile",
  "中等额度": "Medium amount",
  "中等额度推荐": "Recommended for medium amounts",
  "交易推荐": "Recommended for regular transactions",
  "交易记录": "Transaction history",
  "享受只属于你的与众不同": "Enjoy benefits made uniquely for you",
  "今日收益": "Today's profit",
  "代理加盟": "Agent partnership",
  "代理登录": "Agent login",
  "以太坊发行自己的原生代币及其他代币。但成千上万种代币的规则都不一样，这对后期市场发展非常不利。所以代币发行者做了一个智能合约标准，也就是ERC20。": "Ethereum issues its native token and other tokens. Issuers created the ERC20 smart-contract standard.",
  "以太坊网络": "Ethereum network",
  "会员中心": "Member center",
  "会员教程": "Member guide",
  "低": "Low",
  "低手续费，秒级到账。": "Low fee, credited within seconds.",
  "体育游戏规则": "Sports betting rules",
  "使用建议": "Usage recommendation",
  "使用网络": "Network",
  "充值前": "Before depositing",
  "充值后": "After depositing",
  "充值教程": "Deposit guide",
  "充值时间": "Deposit time",
  "充值金额": "Deposit amount",
  "免责说明": "Disclaimer",
  "分享链接": "Share link",
  "到底选哪种协议更好？": "Which protocol should I choose?",
  "前往领取": "Claim now",
  "加入{title}第{days}天": "Day {days} with {title}",
  "加入我们，共赢财富": "Join us and grow together",
  "区别点": "Comparison",
  "协议介绍": "Protocol introduction",
  "博彩责任": "Responsible gaming",
  "历史收益": "Historical profit",
  "地址样式": "Address format",
  "场馆余额": "Venue balance",
  "基本不堵": "Rarely congested",
  "复制成功！": "Copied successfully!",
  "好友接受": "Friend accepts",
  "好友进行": "Friend deposits and bets",
  "如何注册": "How to register",
  "存款投注": "Deposit and bet",
  "安全系数": "Security",
  "安全退出": "Sign out safely",
  "官方全球顶级合作伙伴": "Official global top partner",
  "官方区域合作伙伴": "Official regional partner",
  "尊敬的会员用户": "Dear member",
  "小额交易推荐": "Recommended for small amounts",
  "小额高频": "Small, frequent transactions",
  "尤文图斯": "Juventus",
  "已领取次数": "Times claimed",
  "帮助中心": "Help center",
  "常规交易推荐": "Recommended for regular transactions",
  "彩票投注规则": "Lottery betting rules",
  "得分": "Score",
  "得分：{score}": "Score: {score}",
  "总投注额": "Total bet",
  "总资产": "Total assets",
  "您的邀请": "Your invitation",
  "意见反馈": "Feedback",
  "手机号码注册": "Register with phone number",
  "手机号码注册-输入手机号码，并验证码手机号码。": "Phone registration: enter and verify your phone number.",
  "手续费和速度都介于中间值。": "Fee and speed are between the two options.",
  "手续费用": "Fee",
  "投注前": "Before betting",
  "投注后": "After betting",
  "捕鱼": "Fishing",
  "提现前，请先确保您已成功登录账号。": "Before withdrawing, make sure you are logged in.",
  "提现教程": "Withdrawal guide",
  "早上好，欢迎来到帮助中心": "Good morning, welcome to the help center",
  "时间排行榜": "Time rankings",
  "时间：{time}": "Time: {time}",
  "普通": "Standard",
  "更多公告": "More announcements",
  "有效流水": "Valid turnover",
  "期数": "Period",
  "未登录": "Not logged in",
  "条款协议内容": "Terms and conditions",
  "极快": "Very fast",
  "欢迎来到{title}": "Welcome to {title}",
  "欢迎来到平台，我们致力于通过精良的技术、前卫的产品，成为亚洲博彩业的领导品牌": "Welcome to our platform through strong technology and forward-looking products.",
  "步骤如下": "Steps",
  "永久域名": "Permanent domain",
  "没有找到解决办法？请联系": "Could not find a solution? Contact ",
  "波场网络": "TRON network",
  "活动时间: 长期有效": "Promotion period: ongoing",
  "活动记录": "Activity history",
  "游戏排行榜": "Game rankings",
  "游戏规则_体育内容": "<div class=\"sports-games-article\"><div class=\"main-container-title\">General sports rules</div><div class=\"main-container-content\"><p>All bets follow these terms. Review each market before submitting. Cancelled or delayed events may be voided according to the applicable rules.</p><ol><li>Review selections before submitting.</li><li>Submitted bets cannot be changed or cancelled.</li><li>Official results and platform records are final for settlement.</li><li>Live bets may be delayed or rejected after a material event.</li></ol></div></div>",
  "游戏规则_彩票内容": "<div class=\"lottery-games-article\"><div class=\"main-container-title\">Lottery rules</div><div class=\"main-container-content\"><p>Lottery markets are settled using the official draw result. Review the market definition, closing time and payout conditions before betting.</p><p>Void, cancelled or delayed draws follow the applicable market rules.</p></div></div>",
  "游戏规则_电子游戏内容": "<div class=\"electron-games-article\"><div class=\"main-container-title\">Electronic game rules</div><div class=\"main-container-content\"><p>{brand} electronic games use certified random outcomes. Play responsibly and review the paytable before betting.</p><p>Results are settled according to the displayed rules and the platform record.</p></div></div>",
  "游戏规则_真人内容": "<div class=\"immortal-games-article\"><div class=\"main-container-title\">Live casino rules</div><div class=\"main-container-content\"><p>Live roulette, baccarat and dice games are operated by a live dealer. Select a market and submit your stake before betting closes.</p><p>Rules, payouts and settlement conditions are displayed for each table.</p></div></div>",
  "电子游戏规则": "Electronic game rules",
  "登录后查看": "Log in to view",
  "登录平台-个人信息-卡片管理-添加数字货币地址": "Platform - Personal information - Card management - Add cryptocurrency address",
  "真人娱乐规则": "Live casino rules",
  "真人娱乐，体育投注，电子游艺等尽在一手掌握": "Live casino, sports betting and electronic games in one place",
  "福利中心": "Welfare center",
  "立享会员特权": "Enjoy member privileges now",
  "立即登录": "Log in now",
  "第一步：在网站或App上直接点击注册；": "Step 1: Tap Register on the website or app.",
  "第三步：按照提示填写资料；": "Step 3: Follow the prompts to complete your details.",
  "第三步：设置账户昵称": "Step 3: Set an account nickname",
  "第二步：按照提示填写资料；": "Step 2: Follow the prompts to complete your details.",
  "第二步：按照提示填写资料；；": "Step 2: Follow the prompts to complete your details.",
  "第五步：注册成功。": "Step 5: Registration complete.",
  "第四步：注册成功": "Step 4: Registration complete",
  "第四步：设置账户昵称。": "Step 4: Set an account nickname.",
  "等级": "Level",
  "等级排行榜": "Level rankings",
  "等级：{level}": "Level: {level}",
  "红包记录": "Red-packet history",
  "红包金额": "Red-packet amount",
  "经常拥堵": "Often congested",
  "给你好友": "To your friends",
  "网络状态": "Network status",
  "联系我们": "Contact us",
  "至": "to",
  "若相关问题仍未解决，可咨询在线客服": "If the issue remains unresolved, contact online support.",
  "虚拟币提现": "Cryptocurrency withdrawal",
  "虚拟币支付": "Cryptocurrency payment",
  "设置登录密码。": "Set a login password.",
  "豪礼赠送": "Gifts",
  "账户名注册": "Register with username",
  "账户名注册-输入账户名和密码。。": "Username registration: enter a username and password.",
  "账户设置": "Account settings",
  "购买虚拟币": "Buy cryptocurrency",
  "赞助": "Sponsors",
  "赞助信息": "Sponsorship",
  "转账速度": "Transfer speed",
  "退出系统": "Exit",
  "选择数字货币": "Select cryptocurrency",
  "邀请有好礼 红包等你": "Invite friends and claim red packets",
  "阿斯顿维拉": "Aston Villa",
  "隐私政策提示": "Privacy policy notice",
  "高": "High",
  "1. 打开并登录欧意APP": "1. Open and sign in to the OKX app",
  "1. 选择数字货币": "1. Select cryptocurrency",
  "2. 输入充值金额": "2. Enter the deposit amount",
  "2. 选择快捷买币": "2. Choose quick buy",
  "3. 复制地址或进行扫码": "3. Copy the address or scan the QR code",
  "3. 点击去购买": "3. Tap Buy now",
  "4. 打开并登录欧易软件": "4. Open and sign in to the exchange app",
  "4. 输入购买金额": "4. Enter the purchase amount",
  "5. 可持续二次购买": "5. You can make another purchase",
  "5. 进入“资金”选择“提现”": "5. Open Funds and select Withdraw",
  "6. 选择USDT币种": "6. Select USDT",
  "7. 点击提交按钮": "7. Tap Submit",
  "VIP收益": "VIP profit",
  "参与期数": "Participating periods",
  "团队俑金返水": "Team commission rebate",
  "团队彩金": "Team bonus",
  "团队总剩余": "Team balance",
  "团队总提现": "Team withdrawals",
  "团队总流水": "Team turnover",
  "团队总盈利": "Team profit",
  "团队退水": "Team refund",
  "当前游戏无房间": "No rooms are available for this game",
  "条款与规则": "Terms and rules",
  "消息": "Messages",
  "玩家详情": "Player details",
  "虚拟货币支付": "Cryptocurrency payment",
  "返点收益": "Rebate income",
  "香港六合彩": "Hong Kong Mark Six",
  "AG真人": "AG Casino",
  "AG电子": "AG Electronic",
  "BG真人": "BG Casino",
  "FB体育": "FB Sports",
  "KY棋牌": "KY Chess",
  "PG电子": "PG Slots",
  "专业模式": "Professional mode",
  "群控模式": "Group mode",
  "进入游戏": "Enter game",
  "大厅选择": "Chọn sảnh",
  "选择房间": "Chọn phòng",
  "房间规则": "Quy tắc phòng",
  "新手推荐": "Đề xuất cho người mới",
  "最热门": "Phổ biến nhất",
  "VIP专属": "Dành riêng cho VIP",
  "MI28-中级": "MI28 - Trung cấp",
  "MI28-高级": "MI28 - Cao cấp",
  "MI28-5分钟": "MI28 - 5 phút",
  "MI28-5分钟-中级": "MI28 - 5 phút - Trung cấp",
  "MI28-5分钟-高级": "MI28 - 5 phút - Cao cấp",
  "房间规则1": "1. VIP 1 phù hợp cho người mới trải nghiệm",
  "房间规则2": "2. VIP 2 có tỷ lệ cược cao hơn, phù hợp người chơi nâng cao",
  "房间规则3": "3. VIP 3 có tỷ lệ cược cao nhất và dịch vụ độc quyền",
  "分钟": "phút",
}



// WEBPACK FOOTER //
// ./src/locales/lang/Vietnamese.js